<!-- TicketCheckDialog.vue -->
<template>
    <el-dialog title="Duplicate Ticket Warning"
               :visible.sync="dialogVisible"
               width="30%"
               append-to-body
               @close="handleClose">
        <span>
            Ticket {{ existingTicketId }} was generated on {{ existingTicketDate }},
            please review to ensure a duplicate ticket is not being created.
        </span>
        <span slot="footer" class="dialog-footer">
            <el-button @click="handleCancel">Cancel</el-button>
            <el-button type="primary" @click="handleContinue">Continue Anyway</el-button>
        </span>
    </el-dialog>
</template>

<script>
    export default {
        name: 'duplicate-ticket-warning',
        props: {
            visible: {
                type: Boolean,
                required: true
            },
            existingTicketId: {
                type: String,
                default: ''
            },
            existingTicketDate: {
                type: String,
                default: ''
            }
        },
        computed: {
            dialogVisible: {
                get() {
                    return this.visible;
                },
                set(value) {
                    this.$emit('update:visible', value);
                }
            }
        },
        methods: {
            handleClose() {
                this.$emit('close');
            },
            handleCancel() {
                this.$emit('cancel');
            },
            handleContinue() {
                this.$emit('continue');
            }
        }
    };
</script>


// WEBPACK FOOTER //
// ClientApp/app/servicetickets/components/DuplicateTicketWarning.vue